module.exports = __webpack_public_path__ + "img/file----------@1x.ffc50b8c.png";